// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"7d729081","977":"7c53ce91"}[chunkId] + ".chunk.js";
};